import { RAIL_BASENAME } from 'helpers/rail';
import type { FC } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Page404 } from './404';
import { Eligibility } from './Eligibility';
import { MaintenanceStaticPage } from './Maintenance';
import ElectronicDeliveryConsent from './Payments/ElectronicDeliveryConsent';
import Payment from './Payments/Payment';
import RetrieveQuote from './RetrieveQuote';
import { SubmissionRenderer } from './SubmissionRenderer';
import WelcomeBack from './WelcomeBack';

const Routes: FC = () => {
  const router = createBrowserRouter(
    [
      {
        path: '/',
        element: <Eligibility />,
      },
      {
        path: '/submission/:id',
        element: <SubmissionRenderer />,
      },
      {
        path: '/welcome-back',
        element: <WelcomeBack />,
      },
      {
        path: '/retrieve-quote',
        element: <RetrieveQuote />,
      },
      {
        path: '/submission/:id/payment',
        element: <Payment />,
      },
      {
        path: '/electronic-delivery-consent',
        element: <ElectronicDeliveryConsent />,
      },
      {
        path: '/maintenance',
        element: <MaintenanceStaticPage />,
      },
      {
        path: '*',
        element: <Page404 />,
      },
    ],
    { basename: RAIL_BASENAME },
  );
  return <RouterProvider router={router} />;
};

export default Routes;
